/**
 * ScrollDown
 *
 * @since 1.0.0
 */

import Smooth from "smoothscroll"
import debounce from "debounce"

const StickyCTA = () => {
  const buttons = document.querySelectorAll(".js-scroll-up")
  const sticky = document.querySelector(".js-sticky-cta")
  const treshhold = window.innerHeight / 2
  if (!sticky || !buttons) return
  ;[...buttons].forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault()
      Smooth(0, 1000)
    })
  })
  window.onscroll = debounce(function(e) {
    if (window.scrollY > treshhold) {
      sticky.classList.add("c-sticky-cta--active")
    } else {
      sticky.classList.remove("c-sticky-cta--active")
    }
  }, 20)
}

export default StickyCTA



// WEBPACK FOOTER //
// ./src/js/modules/StickyCTA.js